import React, { useState, useEffect } from "react"
import { Modal } from "reactstrap"
import Select from "react-select"
import { getCurrentUser } from "../../../helpers/Utils"
import { toast } from "react-toastify"
import axios from "axios"

export default function LeadSequenceModal(props) {

  const [sequenceType, setSequenceType] = useState("individual")

  const [allUsers, setAllUsers] = useState([])
  const [selectedAllUsers, setSelectedAllUsers] = useState([])

  const [groupedUsers, setGroupedUsers] = useState({})
  const [selectedGroupUsers, setSelectedGroupUsers] = useState({})
  const [groupsLoading, setGroupsLoading] = useState(false)

  /*
  ============================
  GET USERS
  ============================
  */
  const getAllUsers = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem("company_name")}/user?per_page=5000`,
        {
          headers: {
            Authorization: `Bearer ${getCurrentUser()?.token || ""}`,
          },
        }
      )
      setAllUsers(res?.data?.data?.data || [])
    } catch (err) {
      console.log(err)
    }
  }

  /*
  ============================
  GET GROUPS
  ============================
  */
  const getAllGroups = async () => {
    setGroupsLoading(true)

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem("company_name")}/groups`,
        {
          headers: {
            Authorization: `Bearer ${getCurrentUser()?.token || ""}`,
          },
        }
      )

      const groups = res?.data?.data?.data || res?.data?.data || []

      const grouped = {}
      groups.forEach(group => {
        grouped[group.id] = {
          name: group.name,
          users: group.users || [],
        }
      })

      setGroupedUsers(grouped)
      setGroupsLoading(false)

    } catch (err) {
      console.log(err)
      setGroupedUsers({})
      setGroupsLoading(false)
    }
  }

  /*
  ============================
  GET EXISTING SEQUENCE
  ============================
  */
  const getLeadSequence = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem("company_name")}/lead-sequences`,
        {
          headers: {
            Authorization: `Bearer ${getCurrentUser()?.token || ""}`,
          },
        }
      )

      const groups = res?.data?.groups || []
      const users = res?.data?.users || []

      if (groups.length > 0) {

        setSequenceType("group")

        const groupMap = {}

        groups.forEach(group => {
          const groupUsers = users.filter(
            u => u.group_id === group.group_id
          )

          groupMap[group.group_id] = groupUsers.map(u => ({
            value: u.user_id,
            label: u.name
          }))
        })

        setSelectedGroupUsers(groupMap)

      } else {

        setSequenceType("individual")

        const selectedUsers = users.map(u => ({
          value: u.user_id,
          label: u.name
        }))

        setSelectedAllUsers(selectedUsers)
      }

    } catch (err) {
      console.log(err)
    }
  }

  /*
  ============================
  INIT
  ============================
  */
  useEffect(() => {
    getAllUsers()
    getAllGroups()
  }, [])

  /*
  ============================
  MODAL OPEN
  ============================
  */
  useEffect(() => {
    if (props.nwemodal_leadsequence) {

      setSelectedAllUsers([])
      setSelectedGroupUsers({})
      setSequenceType("individual")

      getLeadSequence()
    }
  }, [props.nwemodal_leadsequence])

  /*
  ============================
  OPTIONS
  ============================
  */
  const userOptions = allUsers.map(u => ({
    value: u.id,
    label: u.name,
  }))

  /*
  ============================
  GROUP USER SELECT
  ============================
  */
  const handleGroupUserSelection = (selected, groupId) => {
    setSelectedGroupUsers(prev => ({
      ...prev,
      [groupId]: selected || [],
    }))
  }

  /*
  ============================
  SAVE
  ============================
  */
  const handleSave = async () => {
    try {

      let payload = {}

      /*
      ===== INDIVIDUAL =====
      */
      if (sequenceType === "individual") {

        if (selectedAllUsers.length === 0) {
          toast.error("Please select users")
          return
        }

        payload = {
          sequence_type: "individual",
          users: selectedAllUsers.map((u, i) => ({
            user_id: u.value,
            sequence_order: i + 1,
            is_pointer: i === 0 ? 1 : 0
          }))
        }
      }

      /*
      ===== GROUP =====
      */
      if (sequenceType === "group") {

        const validGroups = Object.entries(selectedGroupUsers)
          .filter(([_, users]) => users.length > 0)

        if (validGroups.length === 0) {
          toast.error("Please select group users")
          return
        }

        payload = {
          sequence_type: "group",
          groups: validGroups.map(([groupId, users], i) => ({
            group_id: groupId,
            user_ids: users.map(u => u.value),
            sequence_order: i + 1,
            is_pointer: i === 0 ? 1 : 0
          }))
        }
      }

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem("company_name")}/lead-sequences`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${getCurrentUser()?.token || ""}`,
          },
        }
      )

      toast.success(res.data.message)

      props.setnew_leadsequence(false)

    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Something went wrong"
      )
    }
  }

  return (
    <Modal isOpen={props.nwemodal_leadsequence} centered>

      <div className="modal-header">
        <h5 className="modal-title">Lead Sequence</h5>
        <button
          type="button"
          className="cross__btn"
          onClick={() => props.setnew_leadsequence(false)}
        >
          &times;
        </button>
      </div>

      <div className="p-3">

        {/* TYPE */}
        <div className="form-group mb-3">
          <label>Sequence Type</label>

          <select
            className="form-control"
            value={sequenceType}
            onChange={(e) => setSequenceType(e.target.value)}
          >
            <option value="individual">Individual</option>
            <option value="group">Group Wise</option>
          </select>
        </div>

        {/* INDIVIDUAL */}
        {sequenceType === "individual" && (
          <div className="form-group mb-3">
            <label>Select Users</label>

            <Select
              isMulti
              options={userOptions}
              value={selectedAllUsers}
              onChange={(e) => setSelectedAllUsers(e || [])}
            />
          </div>
        )}

        {/* GROUP */}
        {sequenceType === "group" && (
          <div>
            {groupsLoading ? (
              <div className="text-center">Loading...</div>
            ) : (
              Object.entries(groupedUsers).map(([groupId, group]) => {

                const options = group.users.map(u => ({
                  value: u.id,
                  label: u.name,
                }))

                return (
                  <div key={groupId} className="mb-3">
                    <strong>{group.name}</strong>

                    <Select
                      isMulti
                      options={options}
                      value={selectedGroupUsers[groupId] || []}
                      onChange={(e) =>
                        handleGroupUserSelection(e, groupId)
                      }
                    />
                  </div>
                )
              })
            )}
          </div>
        )}

        <button
          className="btn btn-primary mt-3"
          onClick={handleSave}
        >
          Save Sequence
        </button>

      </div>
    </Modal>
  )
}